import * as Sentry from "@sentry/react";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { enqueueSnackbar } from "notistack";

import { QUERY_KEYS, useGetTransportAxiosInstance } from "@/constants";
import useAuth from "@/providers/hooks/useAuth";
import { User } from "@/types/user.types";

export const useGetUsers = ({ hideManagers }: { hideManagers: boolean }) => {
    const { auth } = useAuth();
    const axiosInstance = useGetTransportAxiosInstance();
    return useQuery<User[]>({
        enabled: !!auth?.accessToken,
        queryKey: [QUERY_KEYS.GET_USERS, hideManagers],
        queryFn: async () => {
            try {
                const res = await axiosInstance.get(`/users?hideManagers=${hideManagers}`);

                return res.data?.data;
            } catch (err) {
                Sentry.captureException(err);
                enqueueSnackbar((err as AxiosError<{ message: string }>)?.response?.data?.message, {
                    variant: "error",
                });
                throw new Error((err as AxiosError<{ message: string }>)?.response?.data?.message);
            }
        },
    });
};
